export default __webpack_public_path__ + "static/media/modal-checkmark@2x.6d8784ae.png";